import { styled } from "@vitality-ds/system";
import baseButtonIconStyles from "./styles/BaseButtonIcon.styles";
var ButtonIcon = styled("span", baseButtonIconStyles);
export default ButtonIcon;